import { ACCESS, CREATED_AT, ACTIVE_STATUS } from './admin-constant'

export const LOCAL_STORAGE_JWT_TOKEN = "BNKTKN"
export {
  ACCESS,
  CREATED_AT,
  ACTIVE_STATUS
}